import React from 'react';
import {
    Filter,
    List,
    Edit,
    Create,
    Show,
    SimpleShowLayout,
    Datagrid,
    TextField,
    DateField,
    SimpleForm,
    TextInput,
    DisabledInput,
    EditButton,
    DeleteButton,
    ShowButton
} from 'react-admin';

const SupplierFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

export const SupplierList = (props) => (
	<List title="Suppliers" {...props} filters={<SupplierFilter />} sort={{ field: 'Name', order: 'ASC' }} >
        <Datagrid>
            <TextField source="id" />
            <TextField source="Name" />
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

const SupplierTitle = ({ record }) => {
	return <span>{record ? `"${record.Name ? record.Name : ''}"` : ''}</span>;
};

export const SupplierShow = (props) => (
    <Show title={<SupplierTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Name" />
        </SimpleShowLayout>
    </Show>
);

const required = (message = 'Required') =>
    value => value ? undefined : message;
const validateReq = [required()];

export const SupplierEdit = (props) => (
    <Edit title={<SupplierTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="Name" validate={validateReq} required />
        </SimpleForm>
    </Edit>
);

export const SupplierCreate = (props) => (
    <Create title="Create Supplier" {...props}>
        <SimpleForm>
            <TextInput source="Name" validate={validateReq} required />
        </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/resources/suppliers.js